import CountdownBanner from "@/components/v2/CountdownBanner";
import HeroSection from "@/components/v2/HeroSection";
import { lazy, Suspense } from "react";

const ABVariantSwitcher = lazy(() => import("@/components/v2/ABVariantSwitcher"));
const QuemESection = lazy(() => import("@/components/v2/QuemESection"));
const ReconhecimentoSection = lazy(() => import("@/components/v2/ReconhecimentoSection"));
const DepoimentosVideoSection = lazy(() => import("@/components/v2/DepoimentosVideoSection"));
const ParaQuemSection = lazy(() => import("@/components/v2/ParaQuemSection"));
const ConteudoSection = lazy(() => import("@/components/v2/ConteudoSection"));
const AgendaSection = lazy(() => import("@/components/v2/AgendaSection"));
const ComoFuncionaSection = lazy(() => import("@/components/v2/ComoFuncionaSection"));
const InclusoSection = lazy(() => import("@/components/v2/InclusoSection"));
const FAQSection = lazy(() => import("@/components/v2/FAQSection"));
const CTAFinalSection = lazy(() => import("@/components/v2/CTAFinalSection"));
const FooterSection = lazy(() => import("@/components/v2/FooterSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <CountdownBanner />
      <HeroSection />
      <Suspense fallback={<div className="min-h-[400px]" />}>
        <ConteudoSection />
        <ParaQuemSection />
        <QuemESection />
        <ReconhecimentoSection />
        <DepoimentosVideoSection />
        <AgendaSection />
        <ComoFuncionaSection />
        <InclusoSection />
        <CTAFinalSection />
        <FAQSection />
        <FooterSection />
        <ABVariantSwitcher />
      </Suspense>
    </div>
  );
};

export default Index;
